import { render } from "./patient-report-access.vue?vue&type=template&id=8321fdcc&scoped=true"
import script from "./patient-report-access.vue?vue&type=script&lang=js"
export * from "./patient-report-access.vue?vue&type=script&lang=js"

import "./patient-report-access.vue?vue&type=style&index=0&id=8321fdcc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8321fdcc"]])

export default __exports__